import { Account, CoverageOption, Policy } from "../northstar";
import { User } from "./User";

export interface OOProgramMember {
    id: string;
    name: string;
    dba: string;
    ownerName: string;
    licenses?: string[];

    status: OOProgramPolicyStatus;
    policies: Pick<Policy, "id" | "number" | "effectiveDate" | "expirationDate">[];
    coverages: CoverageOption["id"][];
}

export enum OOProgramPolicyStatus {
    Active = "Active",
    Inactive = "Inactive",
    PendingCancellation = "Pending Cancellation",
}

export interface OOProgramDetails {
    members: OOProgramMember[];
    status: {
        insurance: {
            active: number;
            precancellation: number;
            inactive: number;
        };
    };
    invitations: Pick<OOProgramInvitation, "id" | "accountId" | "name" | "email" | "phone" | "createdDate" | "vin" | "license">[];
}

export interface OOProgramInvitation {
    id: number;

    accountId: string;

    name: string;

    email: string;

    phone: string;

    vin: string;

    license: string;

    createdById: string;

    createdDate: Date;

    isNotificationSent: boolean;

    createdBy: User;

    account: Account;
}
